var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "green", dense: "", dark: "", flat: "" }
                    },
                    [_c("span", [_vm._v("Create")])]
                  ),
                  _c("v-container", [_c("create-unit")], 1)
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "primary", dense: "", dark: "", flat: "" }
                    },
                    [_c("span", [_vm._v("List")])]
                  ),
                  _c("v-container", [_c("table-unit")], 1)
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }